module.exports = __webpack_public_path__ + "img/image6.9751a8c6.png";